"use client";

import {
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { TriangleDots } from "@/components/CustomUI/modules/Loaders";
import CloseButton from "@/components/CustomUI/modals/CloseButton";

const CurrencyContainer = ({
  loading,
  cCode,
  search,
  currencyData,
  handleChangeText,
  handlePress,
  onOpenChange,
}) => {
  return (
    <DropdownMenuContent
      className="
          max-w-[50vw] lg:max-w-[40vw] xl:max-w-[30vw] 
          z-50 p-4 pt-0 max-h-[80vh] 
          overflow-y-scroll vertical-scrollbar 
          hidden md:block relative
          mr-1 mt-1 md:mt-4 
        "
    >

      <div
        className="
            sticky top-0 w-full h-[60px] 
            bg-white flex space-x-2 items-center
          "
      >

          <span className="text-font-navHeader">Change Currency</span>
          <TriangleDots loading={loading} />
          <div className="flex flex-[0.95]">
            <input
              className="
                  p-2 border-[0.7px] border-[#bdbdbd] 
                  text-font-primaryMuted text-[11px] h-[25px] 
                  w-full hover:outline-none focus:outline-none
                  placeholder:italic placeholder:text-slate-400
                  placeholder:text-sm placeholder:tracking-wide 
                "
              placeholder="Search"
              type="text"
              value={search}
              onChange={handleChangeText}
            />
          </div>


      </div>

      {currencyData.length === 0 && (
        <div
          className="
              flex flex-col items-center justify-center 
              min-w-[50vw] lg:min-w-[40vw] xl:min-w-[30vw] h-[30vh]
            "
        >
          <p
            className="
                text-center text-base 
                text-orange-700 
              "
          >
            No currency found:
          </p>
          <p className="text-center text-sm line-clamp-1 overflow-hidden text-ellipses text-orange-700 ">
          {search}
          </p>
        </div>
      )}

      <div
        className="
            grid grid-cols-2 sm:grid-cols-3 
            grid-cols-4 gap-4 pt-5 pb-3
          "
      >
        {currencyData.map((cItem) => (
          <Button
            variant="outline"
            key={cItem.code}
            className={`
                  capitalize px-0 py-0 min-h-[60px]
                  ${cCode === cItem.code && "bg-[#45d4d5]"}
                  hover:bg-[#45d4d5] font-medium	
                  tracking-wide	overflow-hidden
                  text-xs md:text-sm 
                `}
            onClick={() => handlePress(cItem)}
          >
            <span
              className={`md:hidden ${cCode === cItem.code && "text-font-darkBlue"}`}
            >
              {cItem.code}
            </span>
            <span
              className={`
                    hidden md:block break-normal max-w-full
                    ${cCode === cItem.code && "text-white"}
                  `}
            >
              {cItem.name}
            </span>
          </Button>
        ))}
      </div>
    </DropdownMenuContent>
  );
};

export default CurrencyContainer;
